<template>
  <section class="lymphomap_main">
    <div class="member_connected_user_list_wrp">
      <div>
        <div class="row align-items-center">
          <div class="col-sm-auto">
            <h2 class="main_heading">
              <button type="button" class="btn back_btn" @click="$router.go(-1)">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
              </button>
              Connected Members
            </h2>
          </div>

          <div class="col member_search_filter_wrp">
            <div class="ml-auto member_search_filter_box">
              <label 
                class="member_search_filter_label" 
                :class="{ show_search: isSearchOpen }"
              >
                <i class="fa fa-search" @click="isSearchOpen = true"></i>
                <form @submit.prevent="executeSearch">
                  <input
                    type="text"
                    placeholder="Search"
                    v-model.trim="searchTerm"
                    name="search_term"
                    class="form-control"
                    @input="onSearchInput"
                    @focus="isSearchOpen = true"
                    @blur="onSearchBlur"
                    autocomplete="off"
                  >
                </form>
              </label>
            </div>
          </div>
        </div>

        <!-- Filter Carousel -->
        <div class="member_list_filters_wrp" v-if="filterCountList && filterCountList.length">
          <carousel
            :mouseDrag="sliderTouchDrag"
            :touchDrag="sliderTouchDrag"
            :autoplay="false"
            :loop="false"
            :nav="false"
            :margin="15"
            :dots="false"
            :items="4"
            :responsive="{ 1900: { items: 6 }, 1600: { items: 4 }, 1025: { items: 4 }, 560: { items: 2 }, 320: { items: 1 } }"
          >
            <template slot="prev">
              <span class="member_slider_arrow member_slider_prev">
                <i class="fa fa-angle-left" aria-hidden="true"></i>
              </span>
            </template>

            <div
              class="carousel_item animation_zoom_out"
              v-for="filter in filterCountList"
              :key="filter.id || filter.filter_key"
            >
              <div
                class="total_count_box"
                :class="{ active: disabledFilters === filter.filter_key }"
                @click="filteredMemberList(filter.filter_key, filter.count)"
              >
                <div class="count_icon">
                  <span class="filter_cat_img_box">
                    <img :src="filter.image" :alt="filter.display_name" class="img-fluid" loading="lazy">
                  </span>
                </div>
                <div class="count_title_w_n">
                  <span class="count_number">{{ filter.count || 0 }}</span>
                  <span class="count_title">
                    <div v-html="filter.display_name" class="global_filter_name_in_html"></div>
                  </span>
                </div>
              </div>
            </div>

            <template slot="next">
              <span class="member_slider_arrow member_slider_next">
                <i class="fa fa-angle-right" aria-hidden="true"></i>
              </span>
            </template>
          </carousel>
        </div>

        <!-- Members Table -->
        <div class="table-responsive top_brd member_alluser_list pt-1">
          <table class="table">
            <thead>
              <tr>
                <th width="20%" class="member_name">Name</th>
                <th width="18%" class="member_country text-center">Country</th>
                <th width="15%" class="member_city">City</th>
                <th width="15%" class="member_organization">Hospital <br> Organization</th>
                <th width="15%" class="member_area text-center">Department</th>
                <th width="6%" class="member_status">Status</th>
              </tr>
              <tr class="empty_cell"><th colspan="6"></th></tr>
            </thead>

            <tbody>
              <template v-if="memberResults && memberResults.length">
                <tr v-for="member in memberResults" :key="member.id">
                  <td class="m_u_info">
                    <span class="member_user_avtaar">
                      <a href="javascript:void(0)" @click="openUserInfo(member)">
                        <img
                          :src="(member.profile && member.profile.thumbnail) || defaultUserAvatar"
                          :alt="member.first_name || 'User'"
                          width="50"
                          height="50"
                        >
                      </a>
                      <i class="online-status" :class="{ online: member.is_online }"></i>
                    </span>
                    <span class="member_user_info">
                      <span class="member_user_name">
                        <a href="javascript:void(0)" @click="openUserInfo(member)">
                          {{ member.salutation }} {{ member.first_name }} {{ member.last_name }}
                        </a>
                      </span>
                      <span class="user_event_info">
                        <label class="user_personal_status badge badge-success">connected</label>
                      </span>
                    </span>
                  </td>

                  <td class="text-center m_u_country_flag">
                    <img 
                      :src="getCountryFlag(member.profile ? member.profile.country : 'in')" 
                      class="country-flag" 
                      alt="Flag"
                      loading="lazy"
                    />
                  </td>

                  <td class="m_u_city_flag">
                    <span>{{ (member.profile && member.profile.city) || '-' }}</span>
                  </td>

                  <td class="m_u_area_of_work">
                    <span class="member_hosiptal" v-if="member.profile && member.profile.area_of_work">
                      {{ member.profile.area_of_work }}
                    </span>
                    <span class="blank_val" v-else>-</span>
                  </td>

                  <td class="text-center m_u_department">
                    <span class="member_department" v-if="member.profile && member.profile.department">
                      {{ member.profile.department }}
                    </span>
                    <span class="blank_val" v-else>-</span>
                  </td>

                  <td class="m_u_status">
                    <label 
                      class="badge" 
                      :class="member.profile && member.profile.is_public ? 'user_status_badge_public badge-info' : 'user_status_badge badge-secondary'"
                    >
                      {{ member.profile && member.profile.is_public ? 'Public' : 'Private' }}
                    </label>
                  </td>
                </tr>

                <tr v-if="nextPageUrl">
                  <td colspan="6" class="text-center pb-0">
                    <button class="btn btn-default load_more_btn" :disabled="userLoading" @click="loadMoreData">
                      {{ userLoading ? 'Loading...' : 'Load More' }}
                    </button>
                  </td>
                </tr>
              </template>

              <tr v-else-if="memberData && !mFilterLoading">
                <td colspan="6" class="text-center">You don't have any connected members</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Loaders -->
        <div class="fixloader userLoading member_filter_list_more_loader" v-if="userLoading">
          <div class="spinner spinner-1"></div>
        </div>
        <div class="fixloader userLoading member_filter_list_loader" v-if="mFilterLoading">
          <div class="spinner spinner-1"></div>
        </div>
      </div>

      <member-user-info-popup 
        :memUsrInfo="memUserInfo" 
        v-if="memUsrInfoPopupState" 
      />
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import { bus } from '@/main';
import carousel from 'vue-owl-carousel';
import { mapGetters } from 'vuex';
import memberUserInfoPopup from '@/components/private/user/connected-user-info';
import root from '@/_helpers/roots';
import toast from '@/services/toast';

const memberFilteredUrl = root.memberConnectedUsersApiUrl.link;
const DEFAULT_AVATAR = require('@/assets/images/user2.png');

export default {
  name: 'member-connected-user-list',
  components: {
    carousel,
    'member-user-info-popup': memberUserInfoPopup
  },
  data() {
    return {
      memberData:null,
      memberResults: [],
      userLoading: false,
      mFilterLoading: false,
      nextPageUrl: '',
      disabledFilters: '',
      searchTerm: '',
      sliderTouchDrag: false,
      isSearchOpen: false,
      searchDebounceTimer: null,
      defaultUserAvatar: DEFAULT_AVATAR,

      // Modal state
      memUsrInfoPopupState: false,
      memUserInfo: null,
      selfUserId: ''
    };
  },
  computed: {
    ...mapGetters([
      'memberConnectedUsersListGetters',
      'selfUserInfoGetters',
      'getConnectedMemberCountGetters'
    ]),
    currentUser() {
      return (this.selfUserInfoGetters && this.selfUserInfoGetters.data) || {};
    },
    filterCountList() {
      return (this.getConnectedMemberCountGetters && this.getConnectedMemberCountGetters.data) || [];
    }
  },
  watch: {
    memberConnectedUsersListGetters: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.data) {
          this.memberData = newVal.data;
          this.memberResults = newVal.data.data || [];
          this.nextPageUrl = newVal.data.next || '';
        }
      }
    },
    memUsrInfoPopupState(isOpen) {
      if (isOpen) {
        document.body.classList.add('notConnectedUserBody');
      } else {
        document.body.classList.remove('notConnectedUserBody');
      }
    }
  },
  created() {
    this.selfUserId = localStorage.getItem('LoginedUserID') || '';
    window.addEventListener('resize', this.onResize, { passive: true });
    this.onResize();
  },
  mounted() {
    bus.$on('userUpdateStatus', this.handleUserStatusUpdate);
    bus.$on('memUsrInfoPopupStateBus', this.handlePopupState);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    document.body.classList.remove('notConnectedUserBody');
    bus.$off('userUpdateStatus', this.handleUserStatusUpdate);
    bus.$off('memUsrInfoPopupStateBus', this.handlePopupState);
    if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);
  },
  beforeRouteLeave(to, from, next) {
    document.body.classList.remove('notConnectedUserBody');
    next();
  },
  methods: {
    onResize() {
      this.sliderTouchDrag = window.innerWidth < 769;
    },
    onSearchBlur() {
      if (!this.searchTerm) {
        this.isSearchOpen = false;
      }
    },
    onSearchInput() {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        this.executeSearch();
      }, 350);
    },
    executeSearch() {
      if (this.searchTerm.length >= 3) {
        this.mFilterLoading = true;
        this.$store.dispatch('memberConnectedUserSearchFun', { search_term: this.searchTerm })
          .then((response) => {
            this.memberData = response.data;
            this.memberResults = (response && response.data && response.data.data) || [];
            this.nextPageUrl = (response && response.data && response.data.next) || '';
          })
          .catch((err) => {
            const errorMsg = err && err.response && err.response.data && (err.response.data.message || err.response.data.msg);
            toast.error(errorMsg || 'Search failed');
          })
          .finally(() => {
            this.mFilterLoading = false;
          });
      } else if (this.searchTerm.length === 0) {
        this.fetchMembers(memberFilteredUrl);
      }
    },
    fetchMembers(url) {
      this.mFilterLoading = true;
      axios.get(url)
        .then((response) => {
          this.memberData = response.data;
          this.memberResults = (response && response.data && response.data.data) || [];
          this.nextPageUrl = (response && response.data && response.data.next) || '';
        })
        .catch((err) => {
          const errorMsg = err && err.response && err.response.data && (err.response.data.message || err.response.data.msg);
          toast.error(errorMsg || 'Failed to fetch members');
        })
        .finally(() => {
          this.mFilterLoading = false;
        });
    },
    filteredMemberList(param, memberCount) {
      if (!memberCount) return;

      const isSameFilter = this.disabledFilters === param;
      this.disabledFilters = isSameFilter ? '' : param;
      const targetUrl = this.disabledFilters 
        ? `${memberFilteredUrl}?filter_type=${param}` 
        : memberFilteredUrl;

      this.fetchMembers(targetUrl);
    },
    loadMoreData() {
      if (!this.nextPageUrl || this.userLoading) return;

      this.userLoading = true;
      axios.get(this.nextPageUrl)
        .then((response) => {
          this.memberData = response.data;
          const res = (response && response.data && response.data.data) || {};
          this.nextPageUrl = res.next || '';
          const newItems = Array.isArray(res.results) ? res.results : (Array.isArray(res) ? res : []);
          if (newItems.length) {
            this.memberResults.push(...newItems);
          }
        })
        .catch((err) => {
          const errorMsg = err && err.response && err.response.data && (err.response.data.message || err.response.data.msg);
          toast.error(errorMsg || 'Failed to load more members');
        })
        .finally(() => {
          this.userLoading = false;
        });
    },
    getCountryFlag(countryCode) {
        const code = (countryCode || 'IN').toUpperCase();
        try {
            return require(`@/assets/images/countries/${code}.svg`);
        } catch (e) {
            return require('@/assets/images/countries/IN.svg');
        }
    },
    handleUserStatusUpdate(data) {
      const user = this.memberResults.find(item => item.id == data.userID);
      if (user) {
        this.$set(user, 'is_online', data.is_online);
      }
    },
    handlePopupState(state) {
      this.memUsrInfoPopupState = state;
    },
    openUserInfo(member) {
      this.memUserInfo = member;
      this.memUsrInfoPopupState = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.member_connected_user_list_wrp {
  color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif;
  letter-spacing: 1px;

  .top_brd {
    min-height: 55vh;
  }

  .table {
    margin-bottom: 0;
    letter-spacing: 0.5px;
    color: #ffffff;
    border-collapse: separate;
    border-spacing: 0 3px;

    thead th {
      border-bottom: 0;
      font-size: 19px;
      padding: 10px 8px;
      font-family: 'MyriadProRegular', 'Lato', sans-serif;
      text-transform: uppercase;
      border-top: 0;
      transition: all ease 0.5s;
      background: rgba(228, 233, 237, 0.1);
      color: #87cefa;
    }

    thead .empty_cell th {
      padding: 0 !important;
      background: none !important;
    }

    tbody td {
      color: #ffffff;
      vertical-align: middle;
      padding: 10px 8px;
      font-size: 20px;
      font-family: 'MyriadProRegular', 'Lato', sans-serif;
      transition: all ease 0.5s;
      height: 120px;
      border-top: 0;
      background: rgba(228, 233, 237, 0.1);
    }

    a:hover {
      text-decoration: none;
    }

    .member_user_avtaar {
      display: inline-block;
      vertical-align: middle;
      position: relative;

      img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        cursor: pointer;
        object-fit: cover;
      }
    }

    .online-status {
      position: absolute;
      right: 4px;
      bottom: 2px;
      border: 1px solid #9E9E9E;
      border-radius: 50%;
      width: 12px;
      height: 12px;
      background: #9E9E9E;

      &.online {
        background-color: #4CAF50;
        border-color: #4CAF50;
      }
      &.busy {
        background-color: #F44336;
        border-color: #F44336;
      }
    }

    .member_user_info {
      display: inline-block;
      vertical-align: middle;
      width: calc(100% - 70px);
      margin-left: 10px;
    }

    .member_user_name {
      line-height: 1;
      font-size: 20px;
      color: #fff;
      display: block;
      cursor: pointer;
      text-transform: capitalize;
      transition: all ease 0.5s;

      a {
        color: #ffffff;
        text-decoration: none;
        text-transform: capitalize;
        &:hover {
          color: #ffd400;
        }
      }
    }

    .country-flag {
      width: 50px;
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
      object-fit: cover;
    }
  }

  .main_heading {
    color: #ffffff;
    font-size: 24px;
    text-transform: uppercase;
    font-weight: bold;
    margin: 0;
  }

  .load_more_btn {
    color: #fff !important;
    background: rgba(255, 255, 255, 0.1);
    padding: 5px;
    min-width: 110px;
    font-size: 16px;
    border-radius: 3px;
    border: 0 !important;
    box-shadow: none !important;
    margin: 15px 0;

    &:hover {
      color: #000 !important;
      background: #87cefa;
    }
  }

  .user_event_info {
    margin-top: 15px;
    display: block;
  }

  .badge {
    font-weight: normal;
    font-size: 16px;
    margin-bottom: 0;
    transition: all ease 0.5s;

    &.user_personal_status.badge-secondary {
      background-color: #0b2ba3;
    }
    &.user_status_badge_public {
      background-color: #28a745;
    }
  }

  .member_hosiptal {
    display: block;
    max-width: 180px;
  }

  .blank_val {
    font-size: 40px;
    line-height: 1;
  }

  .member_list_filters_wrp {
    padding: 12px 0;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    position: relative;

    .total_count_box {
      background: linear-gradient(-30deg, rgba(37, 44, 84, 0.6) 0%, rgba(0, 0, 0, 0.6) 50%, rgba(38, 38, 38, 0.6) 50%, rgba(44, 44, 84, 0.6) 100%);
      padding: 0 0 35px 18px;
      border: 1px solid rgba(93, 93, 93, 0.4);
      border-radius: 5px;
      display: flex;
      align-items: flex-end;
      cursor: pointer;
      color: #fff;
      height: 135px;

      &:hover,
      &.active {
        background: #87cefa;
        color: #000000;

        .count_icon path,
        .count_icon circle,
        .count_icon rect {
          fill: #000000;
        }

        .count_icon span .img-fluid {
          filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(100deg) brightness(0%) contrast(100%);
        }
      }

      &:hover .count_icon span {
        background: rgba(0, 0, 0, 0.1);
      }

      &.active .count_icon span {
        background: rgba(255, 255, 255, 0.15);
      }
    }

    .count_icon span {
      width: 60px;
      display: inline-block;
      height: 60px;
      background: hsla(0, 0%, 100%, 0.1);
      border-radius: 50%;
      text-align: center;
      line-height: 60px;
    }

    .count_title_w_n {
      padding-left: 15px;
    }

    .count_number {
      display: block;
      font-size: 22px;
      font-weight: 600;
    }

    .count_title {
      font-size: 20px;
      text-transform: capitalize;
      line-height: 1;
    }
  }

  .fixloader.member_filter_list_loader {
    align-items: flex-start;
    padding-top: 200px;
  }

  .member_filter_list_more_loader {
    align-items: flex-end;
    padding-bottom: 150px;
  }

  .member_slider_arrow {
    position: absolute;
    z-index: 99;
    top: 50%;
    left: -21px;
    transform: translateY(-50%);

    .fa {
      cursor: pointer;
      font-size: 42px;
      line-height: 28px;
      color: #ffc107;

      &:hover {
        color: #87cefa;
      }
    }

    @media only screen and (max-width: 767px) {
      left: -15px;
    }

    &.member_slider_next {
      right: -21px;
      left: auto;

      @media only screen and (max-width: 767px) {
        right: -15px;
      }
    }
  }

  .member_search_filter_wrp {
    .member_search_filter_box {
      position: relative;
      max-width: 340px;
      width: 100%;
      text-align: right;

      @media only screen and (max-width: 767px) {
        padding-top: 15px;
        max-width: 100%;
      }
    }

    .member_search_filter_label {
      background: linear-gradient(-30deg, rgba(37, 44, 84, 0.6) 0%, rgba(0, 0, 0, 0.6) 50%, rgba(38, 38, 38, 0.6) 50%, rgba(44, 44, 84, 0.6) 100%);
      border: 1px solid rgba(93, 93, 93, 0.4);
      display: inline-flex;
      width: 40px;
      position: relative;
      margin-right: 0;
      vertical-align: middle;
      margin-bottom: 0;
      overflow: hidden;
      height: 36px;
      border-radius: 3px;
      transition: all 0.8s ease;

      &:hover,
      &.show_search {
        width: 100%;
      }

      &.show_search {
        border-color: #ffd400;

        .fa-search,
        .form-control {
          color: #ffd400 !important;
        }
      }

      @media only screen and (max-width: 767px) {
        width: 100%;
      }
    }

    form {
      width: 100%;
    }

    .form-control {
      background: none;
      font-size: 18px;
      color: #ffffff;
      font-family: 'MyriadProRegular', 'Lato', sans-serif;
      border: none;
      height: auto;
      width: 100%;
      line-height: 36px;
      padding: 0 15px;
      box-shadow: none;

      &::placeholder {
        color: #ffffff;
        opacity: 0.8;
      }

      &:focus::placeholder {
        opacity: 0;
      }
    }

    .fa-search {
      font-size: 18px;
      cursor: pointer;
      color: #ffffff;
      line-height: 36px;
      margin-left: 10px;
    }
  }

  .filter_cat_img_box .img-fluid {
    width: 40px !important;
    height: 40px !important;
    display: inline-block !important;
  }

  .animation_zoom_out {
    animation: zoomOutAnimation 0.5s;
  }

  @keyframes zoomOutAnimation {
    from {
      transform: scale(0.97);
    }
    to {
      transform: scale(1);
    }
  }

  @media only screen and (max-width: 769px) {
    .member_alluser_list {
      .table {
        display: block;

        thead {
          display: none;
        }

        tbody {
          display: block;

          tr {
            display: block;
            background: rgba(228, 233, 237, 0.1);
            margin-bottom: 1px;
            padding: 15px 0;
          }

          td {
            display: block;
            text-align: left !important;
            height: auto !important;
            padding: 0 10px;
            background: none !important;

            &.m_u_country_flag,
            &.m_u_city_flag,
            &.m_u_status {
              display: inline-block;
            }

            &.m_u_department,
            &.m_u_info {
              padding-bottom: 10px;
            }
          }
        }
      }
    }
  }
}
</style>